import * as firebase from 'firebase';
import {
    LoaderGoogle,
    LoginError,
    AutGoogleDispatch,
    LoaderFb,
    AuthFbDispatch,
    passCodeLoaderDis,
    errorMessageDispatch,
    AuthSuccess,
    CreateAccountLoader,
    AccountSuccess,
    LoginWithEmailDispatch,
    LoginLoaderDispatch,
    forgetPasswordSuccessfully,
    SharedDataWithCurrentUser,
    profileEidtDispatch,
    // authLinkedWithPoupDispatch
} from '../reducers/container/authDisptach';
import { FavorQuizesData } from '../reducers/container/deatilDispatch';

import { browserHistory } from 'react-router';

export function loginWithGoogle(provider) {
    return dispatch => {
        // console.log(provider,'provider')
        dispatch(LoaderGoogle())
        dispatch(LoginError())
        dispatch(FavorQuizesData())
        firebase.auth().signInWithPopup(provider)
            .then((result) => {
                // var token = result.credential.accessToken;0
                var user = result.user;
                console.log(result, "result")
                let dataTosave = {
                    userName: user.displayName,
                    uid: user.uid,
                    email: user.email,
                    profile: user.photoURL,
                    role: 'School',
                    providerId: result.additionalUserInfo.providerId
                }
                firebase.database().ref('user/' + dataTosave.uid + '/').once('value')
                    .then((data) => {
                        // console.log(data,'data')
                        if (data.val() === null) {
                            dispatch(LoaderGoogle())
                            dispatch(AutGoogleDispatch(dataTosave));
                            browserHistory.push('/login-confirm')
                        }
                        else {
                            firebase.database().ref('test/').once('value', (obj) => {
                                let allQuizes = obj.val();
                                firebase.database().ref('shared/').once('value', (obj) => {
                                    let sharedData = obj.val();
                                    let sharedWithMe = {}
                                    let currentUserUid = dataTosave.uid;
                                    for (var key in sharedData) {
                                        if (currentUserUid in sharedData[key]) {

                                            sharedWithMe[key] = allQuizes[key];
                                            sharedWithMe[key].currentLicense = sharedData[key][currentUserUid].currentLicense;

                                        }
                                    }
                                    dispatch(SharedDataWithCurrentUser(sharedWithMe))
                                    firebase.database().ref('favorite/').once('value', (data) => {
                                        let userinfo = firebase.auth().currentUser.uid
                                        let favData = data.val()
                                        let FavorQuizes = {}
                                        for (var key in sharedWithMe) {
                                            if (key in favData) {
                                                sharedWithMe[key].favQuiz = favData[key];
                                                // FavorQuizes[key] = sharedWithMe[key];
                                                for (var favKey in favData[key]) {
                                                    if (userinfo === favData[key][favKey]) {
                                                        // FavorQuizes[key].favQuiz[favKey] = userinfo;
                                                        FavorQuizes[key] = sharedWithMe[key];
                                                    }
                                                }
                                            }
                                        }
                                        firebase.database().ref('user/' + userinfo + '/').once('value', (obj) => {
                                            let userInfo = obj.val()
                                            dispatch(AutGoogleDispatch(userInfo));
                                            dispatch(FavorQuizesData(FavorQuizes))
                                            dispatch(LoaderGoogle())
                                            browserHistory.push('/home')
                                        })
                                    })
                                })
                            })
                        }
                    }).catch(function (error) {
                        var errorMessage = error.message;
                        dispatch(LoaderGoogle())
                        dispatch(LoginError(errorMessage))
                    });

            }).catch(function (error) {
                // Handle Errors here.
                if (error.code.match('auth/account-exists-with-different-credential')) {
                    let message = 'Your account has been already registered, you can login with email and password or login with Facebook';
                    dispatch(LoaderGoogle())
                    dispatch(LoginError(message))
                } else {
                    var errorMessage = error.message;
                    dispatch(LoaderGoogle())
                    dispatch(LoginError(errorMessage))
                }

            });
    }
}

export function loginWithFacebook(provider) {
    return dispatch => {
        dispatch(LoaderFb())
        dispatch(FavorQuizesData())
        dispatch(LoginError())
        firebase.auth().signInWithPopup(provider)
            .then(function (result) {
                // var token = result.credential.accessToken;
                var user = result.user;
                let dataTosave = {
                    userName: user.displayName,
                    uid: user.uid,
                    email: user.email,
                    profile: user.photoURL,
                    role: 'School',
                    providerId: result.additionalUserInfo.providerId
                }
                console.log(result, "result")
                firebase.database().ref('user/' + user.uid + '/').once('value')
                    .then(function (data) {
                        if (data.val() === null) {
                            dispatch(LoaderFb())
                            dispatch(AuthFbDispatch(dataTosave));
                            browserHistory.push('/login-confirm')
                        }
                        else {
                            firebase.database().ref('test/').once('value', (obj) => {
                                let allQuizes = obj.val();
                                firebase.database().ref('shared/').once('value', (obj) => {
                                    let sharedData = obj.val();
                                    let sharedWithMe = {}
                                    let currentUserUid = user.uid;
                                    for (var key in sharedData) {
                                        if (currentUserUid in sharedData[key]) {

                                            sharedWithMe[key] = allQuizes[key];
                                            sharedWithMe[key].currentLicense = sharedData[key][currentUserUid].currentLicense;

                                        }
                                    }
                                    dispatch(SharedDataWithCurrentUser(sharedWithMe))
                                    firebase.database().ref('favorite/').once('value', (data) => {
                                        let favData = data.val()
                                        let FavorQuizes = {}
                                        for (var key in sharedWithMe) {
                                            if (key in favData) {
                                                sharedWithMe[key].favQuiz = favData[key];
                                                for (var favKey in favData[key]) {
                                                    if (user.uid === favData[key][favKey]) {
                                                        FavorQuizes[key] = sharedWithMe[key];
                                                        FavorQuizes[key].favQuiz[favKey] = user.uid;
                                                    }
                                                }
                                            }
                                        }
                                        // console.log('FavorQuizes', FavorQuizes)
                                        dispatch(FavorQuizesData(FavorQuizes))
                                        firebase.database().ref('user/' + user.uid + '/').once('value', (obj) => {
                                            let userInfo = obj.val()
                                            dispatch(LoaderFb())
                                            dispatch(AuthFbDispatch(userInfo));
                                            browserHistory.push('/home')
                                        })
                                    })
                                })
                            })
                        }
                    }).catch(function (error) {
                        var errorMessage = error.message;
                        dispatch(LoaderFb())
                        dispatch(LoginError(errorMessage))
                    });
            }).catch(function (error) {
                if (error.code.match('auth/account-exists-with-different-credential')) {
                    let message = 'Your account has been already registered, you can login with email and password or login with Google';
                    dispatch(LoaderFb())
                    dispatch(LoginError(message))
                } else {
                    var errorMessage = error.message;
                    dispatch(LoaderFb())
                    dispatch(LoginError(errorMessage))
                }

            });
    }
}
export function CheckAuthConfirmation(info, obj) {
    return dispatch => {
        console.log(info, 'data')
        console.log(obj, 'datafrom Form')
        info.phone = obj.phone;
        info.schoolAddress = obj.schoolAddress;
        info.schoolName = obj.schoolName;
        info.students = obj.students;
        info.userName = obj.userName;
        info.schoolType = obj.schoolType

        console.log(info, 'DATA AFTER ADDING')
        dispatch(passCodeLoaderDis());
        dispatch(errorMessageDispatch());
        firebase.database().ref('passCode/').on("child_added", (value) => {
            let codes = value.val();
            if (codes === obj.keys) {
                firebase.database().ref('user/' + info.uid + '/').set(info)
                    .then(() => {
                        dispatch(passCodeLoaderDis());
                        browserHistory.push('/log-in')
                    }
                    )


            }
            else {
                let errorMessage = 'Passcode invalid ';
                dispatch(passCodeLoaderDis());
                dispatch(errorMessageDispatch(errorMessage));
            }
        })
    }
}

export function emailAndPasswordWithPopUpAction(action, info) {
    return dispatch => {
        console.log(info)
        dispatch(passCodeLoaderDis());
        dispatch(errorMessageDispatch());
        var credential = firebase.auth.EmailAuthProvider.credential(action.email, action.password);
        firebase.auth().currentUser.linkWithCredential(credential)
            .then((user) => {
                // console.log("Account linking success", user.uid);
                if (user.uid !== null) {
                    firebase.database().ref('user/' + user.uid + '/').set(info)
                        .then(() => {
                            firebase.database().ref('test/').once('value', (obj) => {
                                let allQuizes = obj.val();
                                firebase.database().ref('shared/').once('value', (obj) => {
                                    let sharedData = obj.val();
                                    // console.log('publicData',sharedData)
                                    let sharedWithMe = {}
                                    let currentUserUid = user.uid;
                                    for (var key in sharedData) {
                                        // console.log(sharedData[key]);
                                        if (currentUserUid in sharedData[key]) {
                                            // console.log(key)
                                            sharedWithMe[key] = allQuizes[key];
                                        }
                                    }
                                    // console.log(sharedWithMe, 'sharedWithMe');
                                    dispatch(SharedDataWithCurrentUser(sharedWithMe))
                                    firebase.database().ref('favorite/').once('value', (data) => {
                                        let favData = data.val()
                                        let FavorQuizes = {}
                                        for (var key in sharedWithMe) {
                                            if (key in favData) {
                                                sharedWithMe[key].favQuiz = favData[key];
                                                for (var favKey in favData[key]) {
                                                    if (user.uid === favData[key][favKey]) {
                                                        FavorQuizes[key] = sharedWithMe[key];
                                                        FavorQuizes[key].favQuiz[favKey] = user.uid;
                                                    }
                                                }
                                            }
                                        }
                                        dispatch(FavorQuizesData(FavorQuizes))
                                        firebase.database().ref('user/' + user.uid + '/').once('value', (obj) => {
                                            let userInfo = obj.val()
                                            dispatch(passCodeLoaderDis());
                                            dispatch(AuthSuccess(userInfo));
                                            browserHistory.push('/home');
                                        })
                                    })
                                })
                            })
                        })
                        .catch((error) => {
                            let errorMessage = error.message
                            dispatch(passCodeLoaderDis());
                            dispatch(errorMessageDispatch(errorMessage));
                        })
                }
                else {
                    let errorMessage = 'Check your connection and try again';
                    dispatch(passCodeLoaderDis());
                    dispatch(errorMessageDispatch(errorMessage));
                }
            })
            .catch((error) => {
                let errorMessage = error.message;
                dispatch(passCodeLoaderDis());
                dispatch(errorMessageDispatch(errorMessage));
            })

    }
}

export function SignUpAction(action) {
    return dispatch => {
        console.log(action, 'action');
        let passCode = action.key;
        dispatch(CreateAccountLoader())
        dispatch(LoginError());
        delete action.key;
        firebase.database().ref('passCode/').on("child_added", (value) => {
            let codes = value.val();
            if (codes === passCode) {
                firebase.database().ref('/user/').once('value', (snap) => {
                    let allUsers = snap.val();
                    let userNameExist = false;
                    // console.log(allUsers, userObj, '---------aaaaaaa');
                    for (var key in allUsers) {
                        if (allUsers[key].userName === action.userName) {
                            console.log('exist');
                            userNameExist = true;
                        }
                    }
                    if (userNameExist === true) {
                        // alert('Username already exist. Choose another one.')
                        dispatch(CreateAccountLoader())
                        dispatch(LoginError('Username already exist. Choose another one.'))
                    }
                    else {
                        firebase.auth().createUserWithEmailAndPassword(action.email, action.password)
                            .then((user) => {
                                action.uid = user.uid;
                                delete action.password;
                                firebase.database().ref('user/' + user.uid).set(action)
                                    .then(() => {
                                        dispatch(CreateAccountLoader())
                                        let success = 'Your Account has been created'
                                        dispatch(AccountSuccess(success));
                                        setTimeout(() => {
                                            browserHistory.push('/');
                                        }, 3000)
                                    })
                                    .catch((error) => {
                                        let errorMessage = error.message;
                                        dispatch(CreateAccountLoader())
                                        dispatch(LoginError(errorMessage))
                                    })
                            })
                            .catch((error) => {
                                // Handle Errors here.
                                var errorMessage = error.message;
                                dispatch(CreateAccountLoader())
                                dispatch(LoginError(errorMessage))

                            });
                    }

                })

            }
            else {
                let errorMessage = 'Passcode invalid';
                dispatch(CreateAccountLoader());
                dispatch(LoginError(errorMessage));
            }
        })

    }
}

export function UserLogInAction(action) {
    return dispatch => {
        dispatch(LoginLoaderDispatch());
        firebase.auth()
            .signInWithEmailAndPassword(action.email, action.password)
            .then((user) => {
                dispatch(LoginError());
                firebase.database().ref('/').child(`user/${user.uid}`).once('value', (snap) => {
                    let userInfo = snap.val();
                    // console.log("userInfo",userInfo)
                    if (userInfo.role === 'School' || userInfo.role === 'school' || userInfo.role.toLowerCase() === 'admin') {
                        firebase.database().ref('test/').once('value', (obj) => {
                            let allQuizes = obj.val();
                            firebase.database().ref('shared/').once('value', (obj) => {
                                let sharedData = obj.val();
                                console.log('allQuizes', allQuizes, 'sharedData')
                                // console.log('publicData',sharedData)
                                let sharedWithMe = {}
                                let currentUserUid = user.uid;
                                for (var key in sharedData) {
                                    // console.log(sharedData[key]);
                                    if (currentUserUid in sharedData[key]) {
                                        console.log(sharedData[key][currentUserUid].currentLicense, 'sharedData[key]')

                                        sharedWithMe[key] = allQuizes[key];
                                        sharedWithMe[key].currentLicense = sharedData[key][currentUserUid].currentLicense;
                                    }
                                }
                                // console.log(sharedWithMe, 'sharedWithMe');
                                dispatch(SharedDataWithCurrentUser(sharedWithMe))
                                firebase.database().ref('favorite/').once('value', (data) => {
                                    if (data.val() !== null) {
                                        let favData = data.val()
                                        let FavorQuizes = {}
                                        for (var key in sharedWithMe) {
                                            if (key in favData) {
                                                sharedWithMe[key].favQuiz = favData[key];
                                                for (var favKey in favData[key]) {
                                                    if (user.uid === favData[key][favKey]) {
                                                        // console.log(favData[key][favKey], "favData[key][favKey]")
                                                        FavorQuizes[key] = sharedWithMe[key];
                                                        FavorQuizes[key].favQuiz[favKey] = user.uid;
                                                    }
                                                }
                                            }
                                        }
                                        // console.log('FavorQuizes', FavorQuizes)
                                        dispatch(FavorQuizesData(FavorQuizes))
                                    }
                                    else {
                                        console.log('no favourite');
                                    }

                                })
                            })
                        })

                        dispatch(LoginLoaderDispatch());
                        dispatch(LoginWithEmailDispatch(userInfo))
                        browserHistory.push('/home');
                    }
                    else {
                        var errorMessage = 'There is no user record corresponding to this identifier.';
                        dispatch(LoginError(errorMessage))
                        dispatch(LoginLoaderDispatch());
                    }
                })
            })
            .catch((error) => {
                var errorMessage = error.message;
                // console.log('errr',errorMessage)
                dispatch(LoginError(errorMessage))
                dispatch(LoginLoaderDispatch());
            });
    }
}

export function sendForgotPasswordEmail(ForgetPasswords) {
    return dispatch => {
        dispatch(forgetPasswordSuccessfully())
        firebase.auth().sendPasswordResetEmail(ForgetPasswords.email)
            .then(() => {
                let sent = 'Check your email and Set your password, Make sure your email is correct.'
                dispatch(forgetPasswordSuccessfully(sent));
                firebase.auth().signOut()
                    .then(() => {
                        dispatch(LoginWithEmailDispatch({}))
                        browserHistory.push('/')
                    }).catch((error) => {
                        var errorMessage = error.message;
                        alert(errorMessage);
                    });
                // console.log(sent, 'sent');
            })
            .catch((error) => {
                // console.log("error", error.message)
                let message = error.message;
                dispatch(forgetPasswordSuccessfully(message));

            });
    }
}


export function UserLogOut() {
    return dispatch => {
        firebase.auth().signOut()
            .then(() => {
                dispatch(LoginWithEmailDispatch({}))
                browserHistory.push('/')
            }).catch((error) => {
                var errorMessage = error.message;
                alert(errorMessage);
            });
    }
}

export function userDetailEdit() {
    return dispatch => {
        let Uid = firebase.auth().currentUser.uid;
        firebase.database().ref('user/' + Uid + '/').once('value', (obj) => {
            let details = obj.val();
            // console.log(details,'details');
            dispatch(profileEidtDispatch(details))
            browserHistory.push('/profile-edit')
        })
    }
}


// WEBPACK FOOTER //
// ./src/action/authAction.jsx